import { createFileRoute } from "@tanstack/react-router";
import ContactsPage from "@/views/admin/contacts/ContactsPage.tsx";

export const Route = createFileRoute("/admin/contacts")({
  component: ContactsPage,
});
